import { ResponseGenerator } from 'common/type';
import { trimQueryData } from 'helpers/params';
import { call, put, takeLatest } from 'redux-saga/effects';

import { getShipMovementAPI } from './api';
import { filterShipMovement, filterShipMovementSuccess, filterShipMovementFailure } from './slice';

function* fetchShipMovement({ payload }: any) {
  try {
    const response: ResponseGenerator = yield call(getShipMovementAPI, trimQueryData(payload));
    yield put(filterShipMovementSuccess(response.data));
  } catch (error) {
    yield put(filterShipMovementFailure());
  }
}

function* watchShipMovement() {
  yield takeLatest(filterShipMovement, fetchShipMovement);
}

export default watchShipMovement;
